import React from 'react';
import PropTypes from 'prop-types';
import { HeadingText } from '@paypalcorp/pp-react';
import CategoryToolTile from './CategoryToolTile';
import { find } from 'lodash';
import { INTENT_PICKS } from '../../../lib/constants';

const IntentRow = props => {
  const {
    fptiImpression,
    fptiClick,
    toolTileProps,
    structuredPSData,
    content = {}
  } = props;

  const {
    flatPSData: { categories = {}, isNewLayoutEligible } = {}
  } = toolTileProps;

  const { intentToolsDisplayed = [] } = structuredPSData;
  const categoriesArr = Object.values(categories);

  const handleClickTool = ({
    fptiLink,
    prod,
    PSUrl,
    categoryRank,
    intentRank,
    appKey,
    rank,
    priorityScore
  }) => {
    return () => {
      fptiClick({
        fptiLink,
        prod,
        pageLink: content.categoryFPTI,
        type: INTENT_PICKS,
        categoryRank,
        intentRank,
        appKey,
        rank,
        priorityScore
      });
      fetch(PSUrl);
    };
  };

  const getCategoryLayout = () => {
    if (isNewLayoutEligible) {
      return intentToolsDisplayed.length < 4
        ? ' category-grid singleton'
        : 'category-grid';
    }
    return 'category-row';
  };

  // Display only two or more apps
  return (
    <div id="appcenter-categories">
      <div
        className={
          isNewLayoutEligible ? 'appcenter-category new' : 'appcenter-category'
        }
      >
        <div
          className={
            isNewLayoutEligible ? 'category-header new' : 'category-header'
          }
        >
          <HeadingText level={2} >{content.categoryTitle}</HeadingText>
        </div>
        <div className={getCategoryLayout()}>
          {intentToolsDisplayed.map((intentTool, index) => {
            const intentToolCategory = find(
              categoriesArr,
              obj => obj.categoryKey === intentTool.categoryKey
            );
            return intentToolCategory ? (
              <CategoryToolTile
                key={`category-row-tool-${index}`}
                handleClickTool={handleClickTool}
                tool={intentTool}
                path={`/appcenter/${intentToolCategory.location}`}
                fptiImpression={fptiImpression}
                toolTileProps={toolTileProps}
                hideFavorites={true}
                intentPickType={INTENT_PICKS}
                pageLink={content.categoryFPTI}
                intentRank={index + 1}
              />
            ) : null;
          })}
        </div>
      </div>
    </div>
  );
};

IntentRow.propTypes = {
  toolTileProps: PropTypes.object,
  fptiImpression: PropTypes.func,
  fptiClick: PropTypes.func,
  structuredPSData: PropTypes.object,
  content: PropTypes.object
};

export default IntentRow;
